import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {
    AbstractControl, FormBuilder, FormControl,
    FormGroup, ReactiveFormsModule,
    ValidationErrors,
    Validators
} from "@angular/forms";
import {
    FormLabelComponent
} from "../../../common/forms/form-label/form-label.component";
import {
    AppAlertService,
    ParametersService,
    SettingsAccountService,
    SubtitlesService
} from "../../../core";
import {
    FormPasswordInputComponent
} from "../../../common/forms/form-password-input/form-password-input.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";
import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";

@Component({
  selector: 'password-form',
  standalone: true,
    imports: [
        ReactiveFormsModule,
        FormLabelComponent,
        FormPasswordInputComponent,
        FormButtonComponent,
        FormActionButtonsComponent
    ],
  templateUrl: './password-form.component.html',
  styleUrl: './password-form.component.scss'
})
export class PasswordFormComponent implements OnInit {
    @Output() close = new EventEmitter();
    passwordForm: FormGroup;

    constructor(
        private appAlert: AppAlertService,
        private fb: FormBuilder,
        private parameters: ParametersService,
        public settingsAccount: SettingsAccountService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit(): void {
        this.passwordForm = this.fb.group({
                oldPassword: ['', [Validators.required, Validators.minLength(8)]],
                newPassword: ['', [Validators.required, Validators.minLength(8)]],
                confirmedPassword: ['', [Validators.required, Validators.minLength(8)]]
            },
            {validators: this.passwordMatchValidator}
        );
        this.passwordForm.patchValue({
            oldPassword: this.settingsAccount.accountInformation.oldPassword,
            newPassword: this.settingsAccount.accountInformation.newPassword,
            confirmedPassword: this.settingsAccount.accountInformation.confirmedPassword,
        })
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    closeForm(): void {
        this.close.emit();
    }

    get oldPasswordControl() {
        return this.passwordForm.get('oldPassword') as FormControl;
    }

    get newPasswordControl() {
        return this.passwordForm.get('newPassword') as FormControl;
    }

    get confirmedPasswordControl() {
        return this.passwordForm.get('confirmedPassword') as FormControl;
    }

    passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
        const newPasswordControl = group.get('newPassword');
        const confirmedPasswordControl = group.get('confirmedPassword');

        if (newPasswordControl.errors || confirmedPasswordControl.errors) return null;

        const newPassword = newPasswordControl.value;
        const confirmedPassword = confirmedPasswordControl.value;

        return newPassword === confirmedPassword ? null : { passwordMismatch: true };
    }

    changePassword(): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }

        this.settingsAccount.accountInformation.oldPassword = this.oldPasswordControl.value;
        this.settingsAccount.accountInformation.newPassword = this.newPasswordControl.value;
        this.settingsAccount.accountInformation.confirmedPassword = this.confirmedPasswordControl.value;
        this.settingsAccount.changePassword()
        this.closeForm();
    }
}
